var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8LockWarning50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2165_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 0.166748C11.2708 0.166748 6.58331 4.85425 6.58331 10.5834V14.7501H10.75V10.5834C10.75 7.14591 13.5625 4.33341 17 4.33341C20.4375 4.33341 23.25 7.14591 23.25 10.5834H27.4166C27.4166 4.85425 22.7291 0.166748 17 0.166748Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 41.8333H4.49998C2.20831 41.8333 0.333313 39.9583 0.333313 37.6667V18.9167C0.333313 16.625 2.20831 14.75 4.49998 14.75H29.5C31.7916 14.75 33.6666 16.625 33.6666 18.9167V37.6667C33.6666 39.9583 31.7916 41.8333 29.5 41.8333Z",
    fill: "#FB8C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 25.1667C16.1712 25.1667 15.3763 25.496 14.7903 26.082C14.2042 26.6681 13.875 27.4629 13.875 28.2917C13.875 29.1205 14.2042 29.9154 14.7903 30.5015C15.3763 31.0875 16.1712 31.4167 17 31.4167C17.8288 31.4167 18.6237 31.0875 19.2097 30.5015C19.7958 29.9154 20.125 29.1205 20.125 28.2917C20.125 27.4629 19.7958 26.6681 19.2097 26.082C18.6237 25.496 17.8288 25.1667 17 25.1667Z",
    fill: "#C76E00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2165_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 49.8438C26.8148 49.8438 20.1562 43.1852 20.1562 35C20.1562 26.8148 26.8148 20.1562 35 20.1562C43.1852 20.1562 49.8438 26.8148 49.8438 35C49.8438 43.1852 43.1852 49.8438 35 49.8438Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 32.6562H42.8125V37.3438H27.1875V32.6562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2165_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2165_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LockWarning50);
export default __webpack_public_path__ + "static/media/icons8-lock-warning-50.da51d9fb0ffd7d049f689a4b31ff8e2d.svg";
export { ForwardRef as ReactComponent };